import './style.scss';

import './search.js';

// Slider - Library import example
// import { tns } from "tiny-slider"

document.addEventListener( 'DOMContentLoaded', () => {
	// Lazy load fade in
	document.querySelectorAll( 'img[loading="lazy"]' ).forEach( ( img ) => {
		if( img.complete == true ) {
			img.classList.add( 'has-loaded' );
		}
		img.addEventListener( "load", ( e ) => {
			e.target.classList.add( 'has-loaded' );
		} );
	} );

	// Copyright year
	if( document.querySelector( 'p.copyright' ) ) {
		const date = new Date();
		document.querySelector( 'p.copyright' ).innerHTML = document.querySelector( 'p.copyright' ).innerHTML.replace( '{ YEAR }', date.getFullYear() );
	}

	// AJAX Single Products
	const setButtonQty = ( button, qty ) => {
		// Set to 1 if qty not a valid positive number
		button.dataset['quantity'] = ( parseInt( qty.value ) > 0 ) ? parseInt( qty.value ) : 1;
		// Update qty value also if it's not a valid number
		if( !( parseInt( qty.value ) ) ) {
			qty.value = 1;
		}
	}

	document.querySelectorAll( 'body.single-product form.cart' ).forEach( ( cart ) => {
		let isAvailable = true;
		let variationsData = null;

		// Check if all variations are out of stock and hide form if they are
		if( cart.classList.contains( 'variations_form' ) ) {
			// Get variations JSON data and make an ovbject
			variationsData = JSON.parse( cart.dataset.product_variations );
			if( variationsData ) {
				const variationsInStock = variationsData.filter( ( v ) => v.is_in_stock );
				isAvailable = variationsInStock.length > 0;
			}
			// If all variations are out of stock place message informing of this
			if( !isAvailable && document.querySelector( '.woocommerce-product-details__short-description' ) ) {
				const outOfStockMessage = document.createElement( 'div' );
				outOfStockMessage.classList.add( 'out-of-stock' );
				outOfStockMessage.innerHTML = 'All variations are out of stock';
				document.querySelector( '.woocommerce-product-details__short-description' ).appendChild( outOfStockMessage );
			}
		}
		
		// Is in stock
		const button = cart.querySelector( 'button' );
		// Modify button to work as Ajax Add to Cart
		if( button ) {
			// Stop disabled button from being submitted 
			cart.addEventListener( 'submit', ( e ) => { 
				if( e.target.querySelector( 'button.add_to_cart_button.disabled' ) ) {
					e.preventDefault();
				}
			} );
			// Classes need to trigger inbuilt ajax add to cart
			button.classList = 'button wp-element-button product_type_simple add_to_cart_button ajax_add_to_cart';

			// Product ID (Simple Products)
			if( button.value ) {
				button.dataset['product_id'] = button.value;
			}

			// Variable Products
			if( cart.classList.contains( 'variations_form' ) ) {
				button.classList.add( 'disabled' );
				button.classList.remove( 'ajax_add_to_cart' ); // Will submit even when disabled
				// Don't listen for changes if you know the product is out of stock
				if( isAvailable ) {
					// Watch for variable changes
					cart.addEventListener( 'change', ( e ) => {
						const variation_id = cart.querySelector( 'input[name="variation_id"]' );
						// Add product ID once a variation is set
						setTimeout( () => {
							// Check product is in stock
							if( variationsData ) {
								// Check this product is current and available
								const availableVariation = variationsData.filter( ( v ) => { return ( variation_id.value == v.variation_id && v.is_in_stock ); } );
								if( availableVariation.length > 0 ) {
									button.dataset['product_id'] = variation_id.value;
									// Toggle button state depending on if a variation is set
									button.classList.toggle( 'disabled', false );
									button.classList.add( 'ajax_add_to_cart' );
								}
								// if( variation_id && variation_id.value !== '' ) {
								// }
								else {
									button.classList.toggle( 'disabled', true );
									button.classList.remove( 'ajax_add_to_cart' );
								}
							}

						}, 200 );
					} );
				}
			}
			
			// Qty 
			const qty = cart.querySelector( 'input[name="quantity"]' );
			if( qty ) {
				// Set Qty
				setButtonQty( button, qty );
				// Listen for Qty change
				qty.addEventListener( 'change', ( e ) => { 
					setButtonQty( button, e.target );
				} );
			}
		}
		cart.classList.add( 'is-loaded' );

	} );

	window.addEventListener( 'resize', () => {
		bones_theme_window_height();
	} );
	bones_theme_window_height();

	// Out of Stocks
	// document.querySelectorAll( '.ggc-out-of-stock > a, .ggc-out-of-stock .close' ).forEach( link => {
	// 	link.addEventListener( 'click', ( e ) => {
	// 		e.preventDefault();
	// 		document.querySelector(".ggc-out-of-stock" ).classList.toggle('active');
	// 	} );
	// } );

	document.addEventListener( 'keyup', ( e ) => {
		if( document.querySelector('.ggc-out-of-stock.active') && e.code === "Escape" ) {
			document.querySelector('.ggc-out-of-stock.active').classList.remove( 'active' );
		}
	} );

	// Local storge debug
	if( document.querySelector('#ls-test') ) {
		const stored = [];
		for (const [key, value] of Object.entries(localStorage)) {
			stored.push( key + ': ' + value.length);
		}
		document.querySelector('#ls-test').value = stored.join("\n");
	}

	// Clear old site Local Storage
	if( localStorage.getItem('gccSearch') ) {
		localStorage.setItem('gccSearch', '');
	}
	if( localStorage.getItem('sp_history') ) {
		localStorage.setItem('sp_history', '');
	}
	
} );

const blocks_added_to_cart = ( event ) => {
	if( document.body.classList.contains( 'cart-total-0' ) ) {
		document.body.classList.remove( 'cart-total-0' )
	}
}

document.body.addEventListener( 'wc-blocks_added_to_cart', blocks_added_to_cart );

// iOS window height
const bones_theme_window_height = () => {
  document.documentElement.style.setProperty('--app--height', `${window.innerHeight}px`);

	if( document.querySelector( 'header' ) ) {
		document.documentElement.style.setProperty('--app--header--height', `${document.querySelector( 'header' ).offsetHeight}px`);
	}
}